import { motion } from "framer-motion";

const STORY_IMAGE =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_c8c33088-e275-4c7a-be4e-9570c082ca94/artifacts/5e98mml4_DSCF5696.webp";

const paragraphs = [
  "Eurosteel Limited is a premium supplier of architectural steel products in New Zealand, providing high-quality window and door solutions for both commercial and residential projects. Our product range includes steel windows and doors and other bespoke architectural elements — sourced from trusted partners across Europe and Asia, and finished to combine functionality with aesthetic excellence.",
  "Led by Isaiah Davies, an experienced director with extensive knowledge in construction projects, powder coating, and painting, Eurosteel NZ is committed to delivering precision-crafted steel solutions that meet the highest standards of durability and design. We collaborate closely with architects, builders, and designers to bring innovative visions to life, ensuring every product is tailored to the unique needs of each project.",
  "Our reputation for quality, attention to detail, and exceptional customer service makes Eurosteel a trusted name in the architectural steel industry. We are dedicated to setting new benchmarks in design and construction across New Zealand.",
];

export const OurStory = () => {
  return (
    <section
      id="our-story"
      data-testid="our-story-section"
      className="relative z-10 min-h-screen overflow-hidden px-6 py-28 text-[#f5f3ee] lg:px-16 lg:py-40"
    >
      {/* Full-bleed background image */}
      <img
        src={STORY_IMAGE}
        alt="Bespoke arched steel door with a pool visible through the glass"
        data-testid="our-story-image"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Readability overlays — darker on the RIGHT where the copy sits so
          the black arched door on the LEFT stays clearly visible. */}
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-l from-black/85 via-black/45 to-transparent"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/35"
      />

      {/* Content — right column */}
      <div className="relative mx-auto flex min-h-[calc(100vh-14rem)] max-w-[1500px] items-center justify-end">
        <div
          data-testid="our-story-content"
          className="w-full max-w-xl lg:max-w-2xl"
        >
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
            data-testid="our-story-heading"
            className="text-center font-serif-display text-5xl font-bold uppercase tracking-[-0.01em] text-white drop-shadow-[0_4px_18px_rgba(0,0,0,0.65)] lg:text-7xl"
          >
            Our Story
          </motion.h2>

          <div className="mt-10 space-y-5 text-[15px] leading-[1.75] text-white/90 drop-shadow-[0_2px_8px_rgba(0,0,0,0.7)] lg:text-base">
            {paragraphs.map((p, i) => (
              <motion.p
                key={`${i}-${(p || "").slice(0, 24)}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.8,
                  delay: 0.15 + i * 0.1,
                  ease: [0.19, 1, 0.22, 1],
                }}
                data-testid={`our-story-paragraph-${i + 1}`}
              >
                {p}
              </motion.p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
